import { Component, EventEmitter, OnChanges, OnInit, Output, SimpleChanges, Type } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { SectionEditorBridgeService } from '../../../services/section-editor-bridge.service';
import { NbDialogService } from '@nebular/theme';
import { PreviewEditStoreService } from '../../../services/preview-edit-store.service';
import { BaseSectionEditorDirective } from '../base-section-editor.directive';
import { GridCell, RowCell } from '@urbannex/storethemes';
import { takeUntil } from 'rxjs/operators';
// import { ProductEditorDialogComponent } from '../../dialogs/product-editor-dialog/product-editor-dialog.component';
import { EditState } from '../../../model';
import { EditorDialogComponent } from '../../dialogs/editor-dialog/editor-dialog.component';

@Component({
  selector: 'kve-product-section-editor',
  templateUrl: './product-section-editor.component.html',
  styleUrls: ['./product-section-editor.component.scss']
})
export class ProductSectionEditorComponent extends BaseSectionEditorDirective implements OnInit, OnChanges {
  elementId: string;
  gridThumbnails: any[] = [];
  gridThumbnails$: Subscription;
  cellIdsThumbs: any[];
  cellIdsThumbs$: Subscription;

  selectedCell: GridCell | RowCell;

  @Output() setListMode = new EventEmitter();

  destroy$: Subject<void> = new Subject<void>();

  constructor(sectionEditorBridge: SectionEditorBridgeService,
    private dialogService: NbDialogService,
    previewEditStoreService: PreviewEditStoreService) {
    super(sectionEditorBridge, previewEditStoreService)
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.gridThumbnails$ = this.sectionEditorBridge.getSectionThumbnails().pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        this.gridThumbnails = data;
        this.previewEditStoreService.selectedSection$.subscribe(section => {
          const gridCells: GridCell[] = section.sectionData.gridOptions.gridCells;
          if (gridCells != undefined) {
            gridCells.forEach(gridCell => {
              const selectedCellIdThumb = this.cellIdsThumbs.find(cellThumb => cellThumb.cellId == gridCell.cellId);
              if (selectedCellIdThumb != undefined) {
                selectedCellIdThumb["contentEnum"] = gridCell.contentEnum;
              }
            })
          }
        })
        console.log(this.gridThumbnails);
      })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["selectedRenderedSection"]) {
      this.elementId = this.selectedRenderedSection.elementId;
      // this.section.contentType;
      // this.section.sectionData;
    }
  }

  open(options: any) {
    console.log(options)
    this.previewEditStoreService.setSelectedCell(options.cellId);
    this.resolveSelectedCell(options.cellId);
    const component: Type<any> = EditorDialogComponent;

    const title = "Title"

    // this.previewEditStoreService.updateEditState(EditState.EDITING);
    // this.selectedCell.contentEnum

    const dialogRef = this.dialogService.open(component, {
      context: {
        title: title,
        /* imgSrc:imgSrc,*/
        // cellId:cellId,
        section: this.selectedSection,
        selectedCell: this.selectedCell,
        dialogWidth: 960
      },
    })

    dialogRef.onClose.subscribe((resp: GridCell) => {
      if (resp != undefined) {
        console.log(resp);
        console.log(this.cellIdsThumbs);
        const activeCell = this.cellIdsThumbs.find(cell => cell.cellId == resp.cellId);
        if (activeCell != null && activeCell != undefined) {
          activeCell.imgSrc = resp.imgSrc;
        }
        this.previewEditStoreService.updateSelectedCell(resp);
        // this.previewEditStoreService.updateEditState(EditState.UPDATED)
      }
    })

  }

  goBack(e) {
    this.setListMode.emit();
  }

  resolveSelectedCell(cellId) {
    const cells: GridCell[] = this.selectedSection.sectionData.gridOptions.gridCells;
    if (cells != undefined && cells.length > 0) {
      this.selectedCell = cells.find(cell => cell.cellId == cellId);
    }
  }


}
